import Vue from 'vue'
const VueInputMask = require('vue-inputmask').default

Vue.use(VueInputMask)
